/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

import React, { useEffect } from 'react';
import { ThemeProvider as KitThemeProvider } from '@veeam/components';
import * as themes from '@veeam/components/lib/themes';
import { observer } from 'mobx-react-lite';

import { useGlobalAppData, useGlobalServices } from '../GlobalContextProvider';

export interface ThemeProviderProps {
    children: React.ReactElement;
}

export const ThemeProvider: React.FC<ThemeProviderProps> = observer(({ children }) => {
    const appDataStore = useGlobalAppData();
    const { notificationService } = useGlobalServices();

    useEffect(() => {
        notificationService.setTheme(appDataStore.theme);
    }, [appDataStore.theme]);

    return (
        <KitThemeProvider theme={themes[appDataStore.theme]} parentRef={document.body}>
            {children}
        </KitThemeProvider>
    );
});
